// extracted by mini-css-extract-plugin
export var root = "C_vM";
export var wrapper = "C_vN";
export var image = "C_vP d_w d_y d_W";
export var imageWithHeight = "C_vQ";
export var crop = "C_vR";
export var round = "C_vS";
export var fixedHeight = "C_vT";